/**
 * Transform raw bytes number into user friendly string
 * @param bytes
 * @param decimals
 * @returns {string} formatted size with unit abbreviation
 */
export function formatBytes(bytes: number, decimals = 0): string {
  if (bytes === 0) {
    return '0B';
  }

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + '' + sizes[i];
}

export function pluralize(count: number, type: string, pluralType?: string): string {
  if (count === 1) {
    return `${count} ${type}`;
  } else if (count > 1) {
    return `${count} ${pluralType ?? type + 's'}`;
  } else {
    return '';
  }
}
